import { render, staticRenderFns } from "./GovIdComponent.vue?vue&type=template&id=5b589a1a"
import script from "./GovIdComponent.vue?vue&type=script&lang=js"
export * from "./GovIdComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports